export default "__VITE_ASSET__DWjujVl2__"